// extracted by mini-css-extract-plugin
export default {"label":"PrescriptionTemplateModal_label__VuBnv"};